import React, { useContext, useRef } from 'react';
import { PathContext, LangContext } from 'helpers/contexts';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from 'actions';
import GeneralError from 'components/errors/GeneralError';
import PageBreadcrumbs from './PageBreadcrumbs'
import Loading from 'components/Loading';

const Page = ({ children }) => {
    const dispatch = useDispatch();
    const { currentPath } = useContext(PathContext);
    const { dict } = useContext(LangContext);

    const textNodeRef = useRef();

    const { pageErr, breadCrumbs, isPageError, alternativePageTitle, pageTitleComment } = useSelector(state => state.page)

    const user = useSelector(state => state.user.user);

    const path = currentPath.split('/')[1];
    const name = (path === 'users' && user.role && user.role.code !== 'admin') ? 'users.account' : path;

    const setBreadCrumbs = (data) => {
        dispatch(actions.setBreadCrumbs(data));
    }

    const resetBreadCrumbs = (data) => {
        dispatch(actions.resetBreadCrumbs(data));
    }
    if (isPageError) {
        return <GeneralError errMsg={pageErr.message} />;
    }
    if (!name || !dict[`breadcrumbs.${name}`]) {
        return <Loading />
    }

    return (
        <div className={`page`}>
            <div className={`page__top`}>
                <PageBreadcrumbs
                    user={user}
                    breadCrumbs={breadCrumbs}
                    setBreadCrumbs={setBreadCrumbs}
                    resetBreadCrumbs={resetBreadCrumbs}
                    dict={dict}
                />
                <div className="page__header">
                    {alternativePageTitle ? (
                        alternativePageTitle.toUpperCase()
                    ) : (
                        dict[`breadcrumbs.${name}`].toUpperCase()
                    )}
                </div>
                {pageTitleComment && (
                    <div className="page__header__comment">{pageTitleComment}</div>
                )}

            </div>
            <div className={`page__content`}>
                <div className="page__content__inner" ref={textNodeRef}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Page;
